import { render, staticRenderFns } from "./ColorContrastModal.vue?vue&type=template&id=52e0974a"
import script from "./ColorContrastModal.vue?vue&type=script&lang=js"
export * from "./ColorContrastModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports